import React, {useState} from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import {
    buildOrderFolderPath,
    copyTextToClipboard,
    toLocalExplorerUrl,
} from '../../../../../../utils/orders/OrderFolderPathUtil';

/**
 * Folder icon uses localexplorer: protocol (Local Explorer Integration Module).
 */
const OrderFolderNameCell = ({children, order}) => {
    const path = buildOrderFolderPath(order);
    const folderUrl = path ? toLocalExplorerUrl(path) : null;
    const [snack, setSnack] = useState({open: false, path: null, copied: false});

    const handleMouseDown = (event) => {
        event.stopPropagation();
    };

    const handleOpenFolder = async (event) => {
        // Do not preventDefault — browser must navigate to localexplorer:
        event.stopPropagation();
        const copied = path ? await copyTextToClipboard(path) : false;
        setSnack({open: true, path, copied});
    };

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    minWidth: 0,
                    gap: 0.5,
                }}
            >
                <Box
                    sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        minWidth: 0,
                        flex: 1,
                    }}
                >
                    {children}
                </Box>
                {path && (
                    <Tooltip arrow placement="top" title={`Открыть папку: ${path}`}>
                        <Box
                            component="a"
                            href={folderUrl}
                            onMouseDown={handleMouseDown}
                            onClick={handleOpenFolder}
                            aria-label="Открыть папку заказа"
                            sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                                ml: 'auto',
                                p: 0.25,
                                color: 'inherit',
                                lineHeight: 0,
                            }}
                        >
                            <FolderOpenIcon sx={{fontSize: 18}}/>
                        </Box>
                    </Tooltip>
                )}
            </Box>
            <Snackbar
                open={snack.open}
                autoHideDuration={2000}
                onClose={() => setSnack((prev) => ({...prev, open: false}))}
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
            >
                <Alert
                    severity="info"
                    onClose={() => setSnack((prev) => ({...prev, open: false}))}
                    sx={{alignItems: 'center'}}
                >
                    Открываем: {snack.path}.
                    {snack.copied ? ' Путь скопирован.' : ''}
                    {' '}Нужно расширение Local Explorer (+ Integration Module).
                </Alert>
            </Snackbar>
        </>
    );
};

export default OrderFolderNameCell;
